<template>
  <v-app>
    <v-container fluid class="pa-2">
      <v-form @submit.prevent="submitForm">
        <v-row>

          <!-- LEFT : QC MASTER -->
          <v-col cols="12" md="3">
            <v-expansion-panels v-model="panel" multiple>
              <v-expansion-panel>
                <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">
                  Finishing Information
                </v-expansion-panel-title>

                <v-expansion-panel-text>
                  <v-row dense>

                    <!-- Production Order -->
                    <v-col cols="12 mt-3">
                      <v-select
                        label="Production Order *"
                        v-model="production_order_id.value.value"
                        :items="$store.getters.getProductionOrderList"
                        item-title="code"
                        item-value="id"
                        variant="outlined"
                        density="compact"
                        @update:model-value="onProductionOrderChange"
                        :error-messages="production_order_id.errorMessage.value"
                      />
                    </v-col>

                    <!-- QC Date -->
                    <v-col cols="12">
                      <v-date-input
                        label="Finishing Date *"
                        prepend-inner-icon="mdi-calendar"
                        prepend-icon=""
                        v-model="finishing_date.value.value"
                        density="compact"
                        variant="outlined"
                      ></v-date-input>
                    </v-col>

                  </v-row>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>

          <!-- RIGHT : DETAILS -->
          <v-col cols="12" md="9">

            <v-expansion-panels v-model="panel1" multiple>
              <v-expansion-panel>
                <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">
                  Finishing Details
                </v-expansion-panel-title>

                <v-expansion-panel-text>
                  <v-card flat >
                    <v-card-text>
                      <v-table  cllass="mt-3">
                        <tbody>
                          <tr v-for="(d, i) in details" :key="i">
                            <td>
                              <v-text-field
                                v-model="d.style"
                                type="text"
                                variant="outlined"
                                label="Style*"
                                density="compact"
                                readonly=""
                                disabled=""
                                hide-details
                              ></v-text-field>
                            </td>
                            <td>
                              <v-text-field
                                v-model="d.color_name"
                                type="text"
                                variant="outlined"
                                label="Color*"
                                density="compact"
                                readonly=""
                                disabled=""
                                hide-details
                              ></v-text-field>
                            </td>
                            <td>
                              <v-text-field
                                v-model="d.size_name"
                                type="text"
                                variant="outlined"
                                label="Size*"
                                density="compact"
                                readonly=""
                                disabled=""
                                hide-details
                              ></v-text-field>
                            </td>
                            <td>
                              <v-text-field
                                hide-details
                                v-model.number="d.finished_qty"
                                type="number"
                                variant="outlined"
                                label="Finished Qty*"
                                density="compact"
                              ></v-text-field>
                            </td>
                          </tr>
                        </tbody>
                      </v-table>
                    </v-card-text>

                    <v-card-actions class="justify-end">

                      <v-btn class="bg-grey-darken-1 me-2" variant="flat" @click="submit(0)" :loading="loading && submittingStatus === 0">
                        Draft
                      </v-btn>
                      <v-btn class="bg-primary" variant="flat" @click="submit(1)" :loading="loading && submittingStatus === 1">
                        {{ isEdit ? 'Update' : 'Save' }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>

        </v-row>
      </v-form>
    </v-container>
  </v-app>
</template>

<script setup>
    import { ref,onMounted } from "vue";
    import { useForm, useField } from "vee-validate";
    import { useStore } from "vuex";
    import { useRoute, useRouter } from "vue-router";
    import { toast } from "vue3-toastify";
    import formattedDate from "@/plugins/dateFormatter";

    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const panel = ref([0]);
    const panel1 = ref([0]);
    const isEdit = ref(false);

    const itemList = ref([]);
    const details = ref([]);

    const { handleSubmit, setFieldValue } = useForm({
      initialValues: { status: 1 }
    });

    const production_order_id = useField("production_order_id");
    const finishing_date = useField("finishing_date");

    /* ---------------- EVENTS ---------------- */

    const onProductionOrderChange = (id) => {
      const order = store.getters.getProductionOrderList.find(o => o.id === id);
      itemList.value = order?.items || [];
      itemList.value.forEach(item => {
        details.value = item.breakdowns.map(breakdown => ({
            production_order_item_id: item.id,
            style:item.style?.code,
            production_order_breakdown_id: breakdown.id,
            color_id: breakdown.color_id,
            size_id: breakdown.size_id,
            color_name: breakdown.color.name,
            size_name: breakdown.size.name,
            finished_qty: 0,
        }));
      });
    };

    const submit = (status) => {
      setFieldValue("status", status);
      submitForm();
    };

    const submitForm = handleSubmit((values) => {
      const payload = {
        ...values,
        finishing_date: formattedDate(finishing_date.value.value),
        details: details.value
      };

      const action = isEdit.value
        ? store.dispatch("updateProductionFinishing", { id: route.params.id, data: payload })
        : store.dispatch("saveProductionFinishing", payload);

      action
        .then(() => {
          toast.success("Finishing Saved Successfully");
          router.push({ name: "finishing-records" });
        })
        .catch(err => toast.error(err.response?.data?.message));
    });
    onMounted(async () => {
        await store.dispatch("getProductionOrderList");

        if (route.params.id) {
          isEdit.value = true;
          const id = route.params.id;

          store.dispatch("getProductionFinishingById", { id })
            .then(res => {
              const data = res.data.data;

              setFieldValue("production_order_id", data.production_order_id);
              setFieldValue("finishing_date", data.finishing_date);
              setFieldValue("status", data.status || 1);

              onProductionOrderChange(data.production_order_id);

              details.value = data.details.map(d => ({
                production_order_item_id: d.production_order_item_id,
                style: d?.production_order_item?.style?.code,
                production_order_breakdown_id: d.production_order_breakdown_id,
                color_id: d.color_id,
                size_id: d.size_id,
                color_name: d?.color?.name,
                size_name: d?.color?.name,
                finished_qty: d.finished_qty,
              }));
            })
            .catch(err => {
              console.error(err);
              toast.error("Failed to load Finishing data");
            });
        }
    });

</script>

<style scoped>
.panel-header {
  background: #eceff1;
  font-weight: 600;
}
</style>
